import React from 'react';
import { Box } from '@mui/material';
import QuestionItem from './QuestionItem';

const DraggableQuestionList = ({
  questions,
  topicId,
  onUpdate,
  onDelete,
  onReorder,
  onAttemptUpdate
}) => {
  return (
    <Box>
      {questions.map((question) => (
        <QuestionItem
          key={question.id}
          question={question}
          topicId={topicId}
          onUpdate={onUpdate}
          onDelete={() => onDelete(question.id)}
          onAttemptUpdate={onAttemptUpdate}
        />
      ))}
    </Box>
  );
};

export default DraggableQuestionList; 